import { fetchAtomWithRefresh } from "../../api/store/fetch-atom"

export const getMetricsAtom = fetchAtomWithRefresh(
  "/v3/internal/metrics-configuration"
)
